'use client';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { useState } from 'react';

import { IS_LOCALHOST } from '@/utils/helpers/constants';
import { RouteError } from '@/utils/helpers/fetchRoute';

export function ReactQueryProvider({ children }: React.PropsWithChildren) {
  const [client] = useState(
    new QueryClient({
      defaultOptions: {
        queries: {
          refetchOnWindowFocus: false,
          // A RouteError already waited up to 15s on the backend server-side, so retrying it turned a
          // slow backend into a minute-long spinner; widgets offer Try again instead.
          retry: (failureCount, error) => !(error instanceof RouteError) && failureCount < 3,
        },
      },
    })
  );

  return (
    <QueryClientProvider client={client}>
      {children}
      {IS_LOCALHOST ? <ReactQueryDevtools initialIsOpen={false} position='bottom-right' /> : null}
    </QueryClientProvider>
  );
}
